export default "__VITE_ASSET__D27NfwKK__"